class ProductSlider extends HTMLElement{
    constructor() {
      super();  
    }
    findElements(){
      this.sliderSettingsInfo = this.querySelector('script');
      this.swiperWrap = this.querySelector('.swiper-container');
    }
    setSliderSettings(){
      var {color,directionOption,paginationOption} = {...JSON.parse(this.sliderSettingsInfo.innerHTML)};
      this.color = color;
      this.directionOption = directionOption;
      this.paginationOption = paginationOption;
      this.autoInitSwiper();
    }
    autoInitSwiper(){
      if(this.color == "default"){
        this.initSwiper();
        this.parentElement.classList.remove("hidden");
        this.updateSwiper();
      }
    }
    initSwiper(){
      this.setSliderOptions();
      this.swiperObject = new Swiper(this.swiperWrap, this.SwiperOptions);
      this.isInit = this.swiperObject ? true : false;
    }
    isInitialized(){
      return this.isInit;
    }
    updateSwiper(){
      this.swiperObject.update();
    }
  }
  
  class ProductThumbsSliderElement extends ProductSlider {
    constructor() {
      super();  
      this.findElements();
      this.setSliderSettings();
    }
    setSliderOptions(){
      var defaultThumbsSliderOptions = {
        slidesPerView: 4,
        freeMode: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        loop: false,
        preloadImages: false,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
      },
      }
      var directionThumbsSliderOptions = {
        'horizontal_slider':{
          spaceBetween: 10,
          direction: 'horizontal',
        },
        'vertical_slider':{
          height: 400,
          spaceBetween: 40,
          direction: 'vertical',
        },
        'vertical_slider_desktop_horizontal_mobile':{
          spaceBetween: 10,
          direction: 'horizontal',
          breakpoints: {
            868:{
              height: 400,
              spaceBetween: 40,
              direction: 'vertical',
            }
          },
        },
        'vertical_slider_desktop_only':{
            height: 400,
            spaceBetween: 40,
            direction: 'vertical',
        }
      }
      this.SwiperOptions = {...defaultThumbsSliderOptions,...directionThumbsSliderOptions[this.directionOption]};
    }
  }
  customElements.define('thumbs-product-slider-element', ProductThumbsSliderElement);

  class ProductMainSliderElement extends ProductSlider {
    constructor() {
      super();  
      this.findElements();
      this.setSliderSettings();
    }
    setSliderOptions(){
      this.setThumbsSlider();
      var defaultMainSliderOptions = {
          // Optional parameters
          slidesPerView: 1,
          direction: 'horizontal',
          loop: false,
          observer: true,
          // Navigation arrows
          navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
          },
      
          // // And if we need scrollbar
          scrollbar: {
          el: '.swiper-scrollbar',
          hide: true,
          },            
          thumbs: {
            swiper: this.thumbSlider,
          },
          lazy: {
            loadPrevNext: true,
            checkInView:true,
          },
      }
      // If we need pagination
      var paginationOption = {
        "dynamicBullets" : {
          pagination: {
            el: '.swiper-pagination',
            dynamicBullets: true
          }, 
        },
        "plainBullets" : {
          pagination: {
            el: '.swiper-pagination',
            type:"bullets"
          }, 
        },
        "progressbar":{
          pagination: {
            el: '.swiper-pagination',
            type:"progressbar"
          }, 
        },   
        'fraction':{
          pagination: {
            el: '.swiper-pagination',
            type:'fraction'
          }, 
        },
        "none":{

        }
      }
      this.SwiperOptions = {...paginationOption[this.paginationOption],...defaultMainSliderOptions};

    }
    setThumbsSlider(){
      this.thumbSlider = [...document.querySelectorAll('thumbs-product-slider-element')].find((thumbsSlider)=>{
        return this.color == thumbsSlider.color;
      }).swiperObject;
    }
  }
  customElements.define('main-product-slider-element', ProductMainSliderElement);
